<form #form="ngForm" novalidate class="form-wizard-step">
    <div class="form-wizard-step-header">
        <h4 class="form-wizard-step-title">
            Negócio
        </h4>
        <p class="form-wizard-step-text">
            Informe os dados do negócio.
        </p>
    </div>

    <div class="form-wizard-step-content">
        <!-- Lead -->
        <div class="row" *ngIf="isFaseQualificacao && lead">
            <div class="form-group col-12">
                <label class="col-form-label">Lead</label>
                <input type="text" class="form-control" [value]="lead.nome" disabled="disabled" readonly="readonly">
                <p class="form-text text-muted">
                    {{lead.nomeFantasia}} - {{lead.cnpjCpf}} - {{lead.enderecoPrincipal.cidade?.nome}} - {{lead.enderecoPrincipal.cidade?.estado?.uf}}
                </p>
            </div>
        </div>

        <!-- Cliente -->
        <div class="row" *ngIf="isFaseOportunidade && cliente">
            <div class="form-group col-12">
                <label class="col-form-label">Cliente</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{cliente.pessoa?.codigoIntegracaoErp}}</span>
                    </div>
                    <input type="text" class="form-control" [value]="cliente.pessoa?.nome" disabled="disabled" readonly="readonly">
                </div>
                <p class="form-text text-muted">
                    {{cliente.pessoa?.nomeFantasia}} - {{cliente.pessoa?.cnpjCpf}} - {{cliente.pessoa?.enderecoPrincipal?.cidade?.nome}} - {{cliente.pessoa?.enderecoPrincipal?.cidade?.estado?.uf}}
                </p>
            </div>
        </div>        

        <div class="row">
            <div class="form-group col-12 col-md">
                <label for="negocioUsuarioResponsavel" class="col-form-label">Responsável</label>
                <sgt-usuario-select
                    [idUsuario]="idUsuarioResponsavel"
                    (usuarioChange)="onChangeUsuarioResponsavel($event)"
                    empityName="Nenhum responsável">
                </sgt-usuario-select>            
            </div>
            <div class="form-group col-12  col-md">
                <label for="negocioPrioridade" class="col-form-label">Prioridade</label>
                <sgt-negocio-prioridade-select
                    [idPrioridade]="prioridade"
                    (idPrioridadeChange)="onChangePrioridade($event)">
                </sgt-negocio-prioridade-select>            
            </div>
        </div>
    
        <div class="row">
            <div class="form-group col-12  col-md">
                <label for="negocioDataPrevisaoFechamento" class="col-form-label">Previsão de Fechamento</label>
                <sgt-datepicker [ngModel]="dataPrevisaoFechamento" (ngModelChange)="onChangeDataPrevisaoFechamento($event)" name="negocioDataPrevisaoFechamento" id="negocioDataPrevisaoFechamento" 
                    #negocioDataPrevisaoFechamentoModel="ngModel"  #negocioDataPrevisaoFechamento [ngControl]="negocioDataPrevisaoFechamentoModel">
                </sgt-datepicker>           
            </div>
            <div class="form-group col-12  col-md">
                <label for="negocioValor" class="col-form-label">Valor</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">R$</span>
                    </div>
                    <sgt-decimal2 [ngModel]="valor" (ngModelChange)="onChangeValor($event)" name="negocioValor" #negocioValor="ngModel" #negocioValorDecimal
                        [ngControl]="negocioValor">
                    </sgt-decimal2>           
                </div>
            </div>
        </div> 
        
        <div class="row">
            <div class="form-group col-12">
                <sgt-campanha-select-form
                    #campanhaSelectForm
                    [editMode]="false"
                    [possuiCampanha]="possuiCampanha"
                    [idCampanha]="idCampanha"
                    (idCampanhaChange)="onChangeCampanha($event)"
                    [objetivoVenda]="true"                    
                    possuiCampanhaLabel="Este negócio pertence à uma campanha?"
                    possuiCampanhaHelpText="Selecione se este negócio pertence à uma campanha"
                    possuiCampanhaMsgError="É obrigatório informar se este negócio pertence à uma campanha"
                    campanhaLabelInsert="Qual a campanha deste negócio?"
                    campanhaHelpTextInsert="Selecione a campanha que este negócio pertence"
                    campanhaHelpMsgError="É obrigatório selecionar a campanha que este negócio pertence">
                </sgt-campanha-select-form>
            </div>
        </div>
    </div>


    <div class="form-wizard-step-actions">
        <button type="button" class="btn btn-sm btn-light" (click)="previus.emit()">
            <i class="fas fa-arrow-left"></i> Voltar
        </button>
        
        <button type="button" class="btn btn-sm btn-success" id="negocioBtnCreate" (click)="nextClick()" [disabled]="form.invalid">
            <i class="fas fa-check"></i> {{btnCreateText}}
        </button>
    </div>
</form>